import { createRoutine } from "../utils/routine.utils";
export var reportProblem = createRoutine("SERVICES_REPORT_PROBLEM");
export var reportProblemAddAttachment = createRoutine("SERVICES_REPORT_PROBLEM_ADD_ATTACHMENT");
